import { AdvancedMarker, AdvancedMarkerProps, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';

import ZorgbaseResult from '@/app/api/filter/[postcode]/ZorgbaseResult';

import { getOrganisationDisplayName, markerColorForOrganisation, pointToPosition } from '@/lib/util';
import { useState } from 'react';
import { MapDisplayType } from './MapDisplay';


export interface MapMarkerProps extends Omit<AdvancedMarkerProps, 'position'> {
	organisation: ZorgbaseResult;
	type: MapDisplayType
}

const MapMarker = (props: MapMarkerProps) => {
	const [infowindowOpen, setInfowindowOpen] = useState(false);
	const [markerRef, marker] = useAdvancedMarkerRef();

	const { organisation, type, ...other } = props;
	let iconProps = {
		// path: 'M8 12l-4.7023 2.4721.898-5.236L.3916 5.5279l5.2574-.764L8 0l2.3511 4.764 5.2574.7639-3.8043 3.7082.898 5.236z',
		path: google.maps.SymbolPath.CIRCLE,
		fillColor: markerColorForOrganisation(organisation),
		fillOpacity: 1,
		scale: 8,
		strokeColor: 'white',
		strokeWeight: 1,
	};

	// if(organisation.acceptsPassersBy && organisation.acceptsPatients) {
	// 	iconProps.
	// }

	if (organisation && organisation.visible) {
		if (type === 'All') {
			iconProps = {
				...iconProps,
				scale: 8
			};
		} else {
			// Check if the organisation is a HAP Noord Deelnemer
			switch (organisation[`accepts${type}`]) {
				case 0: // no
					iconProps = {
						...iconProps,
						scale: 6
					};
					break;
				case 1: // yes
					iconProps = {
						...iconProps,
						scale: 10
					};
					break;
				default: // null - unknown
					iconProps = {
						...iconProps,
						scale: 8
					};
					break;
			}
		}
	}

	// const algemeenAdres = JSONPath({ path: '$..Adressen[?(@.Type.Code==1)]', json: organisation })[0];
	// const algemeenAdres = organisation.Adressen![0];
	const markerPosition = pointToPosition(organisation);
	const displayName = getOrganisationDisplayName(organisation);

	return markerPosition && (
		<AdvancedMarker
			ref={markerRef}
			position={markerPosition}
			onClick={(e) => { e.domEvent.preventDefault(); setInfowindowOpen(true) }}
			{...other}
		>
			{organisation.acceptsPatients && organisation.acceptsPassersBy ?
				(
					<div
						onMouseOver={(e) => { e.preventDefault(); setInfowindowOpen(true) }}
						onMouseOut={(e) => { e.preventDefault(); setInfowindowOpen(false) }}
						style={{
							width: iconProps.scale * 2 + 2,
							height: iconProps.scale * 2 + 2,
							position: 'absolute',
							top: 0,
							left: 0,
							background: iconProps.strokeColor,
							border: `2px solid ${iconProps.strokeColor}`,
							borderRadius: '50%',
							transform: 'translate(-50%, -50%)'
						}}>
						{/* eslint-disable-next-line @next/next/no-img-element */}
						<img src="/icons/both.svg" alt={`icon`} style={{ margin: '-3px 0 0 -3px' }} />
					</div>
				) : (
					<div
						onMouseOver={(e) => { e.preventDefault(); setInfowindowOpen(true) }}
						onMouseOut={(e) => { e.preventDefault(); setInfowindowOpen(false) }}
						style={{
							width: iconProps.scale * 2,
							height: iconProps.scale * 2,
							position: 'absolute',
							top: 0,
							left: 0,
							background: iconProps.fillColor,
							border: `2px solid ${iconProps.strokeColor}`,
							borderRadius: '50%',
							transform: 'translate(-50%, -50%)'
						}}
					/>
				)}

			{infowindowOpen && (
				<InfoWindow
					anchor={marker}
					maxWidth={200}
					onCloseClick={() => setInfowindowOpen(false)}
					pixelOffset={[0, -(2 + iconProps.scale)]}
					disableAutoPan={true}
					shouldFocus={false}
					headerContent={displayName}
				/>
			)}
		</AdvancedMarker>
	);
}

export default MapMarker;
